import React from 'react';
import ClassNames from 'classnames';
import PropTypes from 'react-proptypes';

import './input-slider.scss';

const Theme = {
    PURPLE: 'ThemePurple',
};

const InputSlider = ({
    input,
    min,
    max,
    value,
    onChange,
    theme,
    ...rest
}) => {

    const percentTotal = max - min;
    const percentLine = value - min;
    const linePercentage = ((percentLine * 100) / percentTotal);

    return (
        <div className={ClassNames('InputSlider', theme)}>
            <input className="slider" type="range" min={min} max={max} defaultValue={value} onChange={e => onChange(parseInt(e.target.value, 10))} {...input} {...rest} />
            <div className="filled-bar" style={{ width: `${linePercentage}%` }} />
        </div>
    );
};

InputSlider.propTypes = {
    input: PropTypes.any,
    min: PropTypes.number,
    max: PropTypes.number,
    value: PropTypes.number,
    theme: PropTypes.oneOf(Object.keys(Theme).map(el => Theme[el])),
    onChange: PropTypes.func,
};

InputSlider.defaultProps = {
    input: {},
    min: 0,
    max: 0,
    value: 0,
    theme: Theme.PURPLE,
    onChange: () => {},
};

export default InputSlider;

export {
    Theme,
};
